import { LuCalendarDays } from "react-icons/lu";
import { ReferenceList } from "../../../../components/referenceList";
import { setClientSearch } from "../../../../reducers/userConfigSlice";
import { clientOrderCount } from "./clientListModel";
const unavailable = (title) => <span title={title}>—</span>;
const definition = {
  key: "client",
  idKey: "customerId",
  singular: "cliente",
  plural: "clientes",
  nameLabel: "Cliente",
  searchKey: "clientSearch",
  setSearch: setClientSearch,
  filterId: "client-orders",
  filterLabel: "Pedidos",
  filterOptions: () => [
    { value: "with", label: "Con pedidos" },
    { value: "without", label: "Sin pedidos" },
  ],
  matchesFilter: (row, value) =>
    value === "with" ? clientOrderCount(row) > 0 : clientOrderCount(row) === 0,
  searchText: (row) =>
    [row.name, row.phone, row.email, row.nif].filter(Boolean).join(" "),
  filterExtra: (
    <button
      className="clientDateFilter"
      type="button"
      disabled
      title="Fecha disponible al consultar el historial de cada cliente"
      aria-label="Filtrar por fecha: no disponible en este listado"
    >
      Seleccionar fecha <LuCalendarDays aria-hidden="true" />
    </button>
  ),
  bulkRemove: false,
  canToggle: () => false,
  canRemove: () => false,
  exportEnabled: false,
  editLabel: () => "Ver ficha e historial",
  selectAllLabel: "Seleccionar todos los clientes de esta página",
  columns: [
    {
      key: "phone",
      label: "TELÉFONO",
      render: (row) => (
        <span
          className="clientCell"
          title={row.phone || "Teléfono no indicado"}
        >
          {row.phone || "—"}
        </span>
      ),
    },
    {
      key: "email",
      label: "EMAIL",
      render: (row) => (
        <span className="clientCell" title={row.email || "Email no indicado"}>
          {row.email || "—"}
        </span>
      ),
    },
    {
      key: "orders",
      label: "Pedidos",
      className: "catalogProductCount",
      sortValue: (row) => clientOrderCount(row) ?? -1,
      render: (row) => clientOrderCount(row) ?? "—",
    },
    {
      key: "lastOrder",
      label: "ÚLTIMO PEDIDO",
      render: () =>
        unavailable("Consulta las fechas en el historial del cliente"),
    },
    {
      key: "spent",
      label: "Total gastado",
      className: "clientSpent",
      render: () =>
        unavailable("Total acumulado no disponible en este listado"),
    },
  ],
};
export const ClientList = (props) => (
  <ReferenceList {...props} definition={definition} />
);
